module.exports = __webpack_public_path__ + "img/card_bg.b8db7398.png";